import {Component, h} from "preact";
import {Gender, Product} from "../../models/product";
import styles from './style.module.scss';
import {config} from "../../config";
import {connect} from "redux-zero/preact";
import {FilterMap} from "../../models/filter";
import {navigationService} from "../../services/navigation-service";
import actions from "../../store/actions";


export interface Props {
  filters: FilterMap
  product: Product;
  resetStore();
}

const mapToProps = ({filters}) => ({filters});

class ProductBrand extends Component<Props> {
  componentDidMount() {
    this.handleClick = this.handleClick.bind(this);
  }

  render() {

    let src = '';
    let alt = '';

    switch (this.props.product.brand.toLocaleLowerCase()) {
      case 'accessoires':
        src = `${config.publicPath}images/logos/Accessories.png`;
        alt = 'Accessories';
        break;

      case 'amisu':
        src = `${config.publicPath}images/logos/Amisu.png`;
        alt = 'Amisu';
        break;

      case 'athletics' :
      case 'new yorker athletics' :
        src = `${config.publicPath}images/logos/Athletics.png`;
        alt = 'Athletics';
        break;

      case 'black squad':
        src = `${config.publicPath}images/logos/BlackSquad.png`;
        alt = 'BlackSquad';
        break;

      case 'censored' :
        src = `${config.publicPath}images/logos/Censored.png`;
        alt = 'Censored';
        break;

      case 'fbs' :
      case 'fb sister' :
        src = `${config.publicPath}images/logos/FBsister.png`;
        alt = 'FBsister';

        break;
      case 'fsbn':
      case 'fishbone' :
        src = `${config.publicPath}images/logos/FSBN.png`;
        alt = 'Fishbone';
        break;

      case 'smog' :
        src = `${config.publicPath}images/logos/SMOG.png`;
        alt = 'SMOG';
        break;

      case 'icono' :
        src = `${config.publicPath}images/logos/ICONO.png`;
        alt = 'ICONO';
        break;

      case 'iq' :
        src = `${config.publicPath}images/logos/IQ_LOGO.png`;
        alt = 'IQ';
        break;

      default:
        src = '';
        alt = '';
    }

    return (
        <img onClick={this.handleClick} class={styles['brand-logo']} src={src} alt={alt}/>
    )
  }

  async handleClick() {
    if (this.props.product) {
      const gender: Gender = this.props.filters.gender;
      if (this.props.product.brand) {
        this.props.resetStore();
        navigationService.goToBrand(gender, this.props.product.brand);
      }
    }
  }
}

export default connect(mapToProps, actions)(ProductBrand)